module.exports = __webpack_public_path__ + "img/map-GERMANY-de.62a989d9.webp";